module.exports = __webpack_public_path__ + "static/media/venture.b866df1f.png";